import { Link } from 'react-router-dom';
import { User, LogOut, LayoutDashboard, Shield, Mic2, Settings, Calendar } from 'lucide-react';
import { Button } from '../ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { BACKEND_URL } from '../../lib/backend';

export function UserDropdown({ user, isAdmin, isArtist, isAgent, onLogout }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="flex items-center gap-2 text-sm">
          <div className="w-8 h-8 bg-surface-highlight rounded-full flex items-center justify-center overflow-hidden">
            {user?.avatar_url ? (
              <img src={`${BACKEND_URL}${user.avatar_url}`} alt="" className="w-full h-full object-cover" />
            ) : (
              <User className="w-4 h-4" />
            )}
          </div>
          <span className="text-[#A1A1AA]">{user?.username || user?.name}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48 bg-surface border-[#262626]">
        {!isAdmin && !isAgent && (
          <DropdownMenuItem asChild>
            <Link to="/dashboard" className="flex items-center gap-2 cursor-pointer" data-testid="nav-dashboard"><LayoutDashboard className="w-4 h-4" />My Orders</Link>
          </DropdownMenuItem>
        )}
        {isAgent && (
          <DropdownMenuItem asChild>
            <Link to="/agent-dashboard" className="flex items-center gap-2 cursor-pointer" data-testid="dropdown-agent-dashboard"><Calendar className="w-4 h-4" />Agent Dashboard</Link>
          </DropdownMenuItem>
        )}
        {isArtist && !isAdmin && !isAgent && (
          <DropdownMenuItem asChild>
            <Link to="/artists" className="flex items-center gap-2 cursor-pointer" data-testid="nav-browse-artists"><Mic2 className="w-4 h-4" />Browse Artists</Link>
          </DropdownMenuItem>
        )}
        {isAdmin && (
          <DropdownMenuItem asChild>
            <Link to="/admin" className="flex items-center gap-2 cursor-pointer" data-testid="nav-admin"><Shield className="w-4 h-4" />Admin Panel</Link>
          </DropdownMenuItem>
        )}
        <DropdownMenuItem asChild>
          <Link to="/settings" className="flex items-center gap-2 cursor-pointer" data-testid="nav-settings"><Settings className="w-4 h-4" />Settings</Link>
        </DropdownMenuItem>
        <DropdownMenuSeparator className="bg-[#262626]" />
        <DropdownMenuItem onClick={onLogout} className="cursor-pointer text-red-400" data-testid="nav-logout"><LogOut className="w-4 h-4 mr-2" />Logout</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
